import Conversations from '@/api/conversations'
import Users from '@/api/users'

export default {
  namespaced: true,
  state: {
    currentConversation: null,
    newConversationUser: null,
    messages: [],
    conversations: [],
    currentStatus: null
  },
  getters: {
    otherUser: (state, getters, rootState) => conversation => {
      return {
        id: conversation.otherId,
        firstName: conversation.otherFirstName,
        lastName: conversation.otherLastName,
        profilePictureUrl: conversation.imageUrl
      }
    }
  },
  mutations: {
    setConversations (state, conversations) {
      state.conversations = conversations
    },
    setCurrentStatus (state, status) {
      state.currentStatus = status
    },
    setCurrentConversation (state, conversation) {
      state.newConversationUser = null
      state.currentConversation = conversation
    },
    setMessages (state, messages) {
      state.messages = messages
    },
    setNewConversationUser (state, user) {
      state.currentConversation = null
      state.newConversationUser = user
    },
    resetNewConversationUser (state) {
      state.newConversationUser = null
    },
    resetCurrentConversation (state) {
      state.currentConversation = null
    },
    addMessage (state, message) {
      state.messages.push(message)
    },
    setHead (state, message) {
      const conv = state.conversations.find(c => c.id === message.conversationId)
      conv.messageContent = message.content
      conv.date = message.createdAt
    },
    setStatusRead (state, conversationId) {
      const conv = state.conversations.find(c => c.id === conversationId)
      conv.status = 'read'
    },
    setStatusUnread (state, conversationId) {
      const conv = state.conversations.find(c => c.id === conversationId)
      if (conv) {
        conv.status = 'unread'
      }
    }
  },
  actions: {
    async getConversations ({ commit }) {
      const conversations = await Conversations.getConversations()
      commit('setConversations', conversations)
    },
    async sendMessageToUser ({ dispatch, commit }, { userId, content }) {
      const message = await Conversations.sendMessageToUser({
        userId, content
      })

      commit('resetNewConversationUser')

      await dispatch('getConversations')
      await dispatch('getConversation', message.conversationId)
    },
    async sendMessage ({ commit, dispatch, state }, { content }) {
      const message = await Conversations.sendMessageToConversation(
        { conversation: state.currentConversation, content }
      )
      commit('addMessage', message)
      dispatch('getConversation', message.conversationId)
      commit('setHead', message)
    },
    async getConversation ({ commit, dispatch }, conversationId) {
      const conv = await Conversations.getConversation(conversationId)
      commit('setCurrentConversation', conv)
      // commit('setMessages', [])
      await dispatch('getMessages', conversationId)
    },
    async getMessages ({ commit }, conversationId) {
      const messages = await Conversations.getMessagesForConversation(conversationId)
      commit('setMessages', messages)
    },
    async setReadMessage ({ commit }, message) {
      const { conversationId } = message
      await Conversations.updateConversationStatus(
        conversationId, message
      )
    },
    async getConversationForUser ({ commit, state, dispatch }, user) {
      const conv = await Conversations.getConversationWithUser(user)
      if (conv) {
        commit('setCurrentConversation', conv)
        await dispatch('getMessages', conv.id)
      } else {
        commit('setNewConversationUser', user)
      }
    },
    async socket_onMessage ({ commit, state }, { conversationId, message }) {
      const current = state.currentConversation || {}
      if (conversationId === current.id) {
        commit('addMessage', message)
      } else {
        commit('setStatusUnread', conversationId)
      }
      commit('setHead', message)
    },
    async socket_readConversation ({ commit }, conversationId) {
      commit('setStatusRead', conversationId)
    },
    async getUserStatus ({ commit }, user) {
      if (!user) { return }

      const status = await Users.getStatus(user.id)
      commit('setCurrentStatus', status)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/conversations.js